import React, { useEffect } from 'react';
import { Testimonial } from './Testimonial';
import { HeartPulseIcon } from 'lucide-react';
import { trackPurchaseClick, trackSectionView, trackContentEngagement } from './MetaPixelTracker';
export function FractionationSection() {
  useEffect(() => {
    // Track section view when component mounts
    trackSectionView('FractionationSection');
  }, []);
  return <section className="py-16 border-b border-gray-800" data-id="element-122">
      <div className="max-w-3xl mx-auto" data-id="element-123">
        <h2 className="text-3xl font-bold mb-8 text-left" data-id="element-124">
          <span className="bg-gradient-to-r from-red-500 to-orange-500 text-transparent bg-clip-text" data-id="element-125">
            ¿Te ha pasado?
          </span>
        </h2>
        <div className="space-y-6 mb-10" data-id="element-126">
          <p className="text-lg" data-id="element-127">Estar con alguien… y sentir que no estás.</p>
          <p className="text-lg" data-id="element-128">
            Querer responder… y que tu cuerpo diga que no.
          </p>
          <p className="text-lg" data-id="element-129">
            Recordar cómo eras antes… y no saber por qué cambió.
          </p>
          <p className="text-xl font-semibold mt-8" data-id="element-130">
            Pero no estás roto. Solo estás desenfocado. Apagado. Y eso… tiene
            solución.
          </p>
          <div className="bg-gray-900 rounded-lg p-6 border border-gray-800 mt-8" data-id="element-131">
            <p className="text-lg mb-6" data-id="element-132">
              Antes te costaba. Lo sabés. Pero ahora… ella te mira diferente.
              Porque el que sos hoy, no es el mismo de ayer.
            </p>
            <ul className="space-y-4 mb-6" data-id="element-133">
              <li className="flex items-start" onClick={() => trackContentEngagement('benefit', 'fuego_encendido', 'click')} data-id="element-134">
                <span className="text-red-500 mr-2" data-id="element-135">•</span>
                <p data-id="element-136">El fuego encendido.</p>
              </li>
              <li className="flex items-start" onClick={() => trackContentEngagement('benefit', 'mirada_firme', 'click')} data-id="element-137">
                <span className="text-red-500 mr-2" data-id="element-138">•</span>
                <p data-id="element-139">La mirada firme.</p>
              </li>
              <li className="flex items-start" onClick={() => trackContentEngagement('benefit', 'energia_vibrando', 'click')} data-id="element-140">
                <span className="text-red-500 mr-2" data-id="element-141">•</span>
                <p data-id="element-142">Tu energía vibrando.</p>
              </li>
              <li className="flex items-start" onClick={() => trackContentEngagement('benefit', 'pareja_sintonizando', 'click')} data-id="element-143">
                <span className="text-red-500 mr-2" data-id="element-144">•</span>
                <p data-id="element-145">Tu pareja sintonizando con tu nueva frecuencia.</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-146">
          <Testimonial quote="No sé qué tiene… pero funciona. Primera dosis y mi cuerpo lo sintió. A la noche… fue otro nivel." author="Mariano G." location="Córdoba" imageSrc="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80" testimonialId="testimonial_mariano" data-id="element-147" />
          <Testimonial quote="Pensé que era cansancio por estrés. Pero era falta de chispa. Esto me la devolvió." author="Iván T." location="Rosario" imageSrc="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" testimonialId="testimonial_ivan" data-id="element-148" />
        </div>
        <div className="bg-gray-900 rounded-lg p-6 mb-10 text-white relative border border-gray-800" onClick={() => trackContentEngagement('expert', 'dr_elias_fontana', 'view')} data-id="element-149">
          <div className="flex justify-center mb-4" data-id="element-150">
            <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-gray-700" data-id="element-151">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jBrYqDVzbvhjUamL4sBrJ4/Imagen_de_WhatsApp_2025-09-18_a_las_21.25.55_c7e848cd.jpg" alt="Dr. Mateo Rivas" className="w-full h-full object-cover" data-id="element-152" />
            </div>
          </div>
          <div className="absolute top-4 left-6 text-red-600 text-4xl font-serif" data-id="element-153">
            "
          </div>
          <div className="text-gray-300 text-sm leading-relaxed space-y-4 px-2" data-id="element-154">
            <p data-id="element-155">
              Durante más de 20 años trabajé como bioquímico en laboratorios de
              Argentina, desarrollando fórmulas para la industria farmacéutica.
              Pero irónicamente, cuando empecé a sentir el bajón físico, mental
              y sexual… nada de lo que conocía funcionaba como prometía.
            </p>
            <p data-id="element-156">
              Probé cápsulas, estimulantes, y técnicas mentales. Todo era
              momentáneo. Algo en mí sabía que la solución tenía que ser más
              profunda… más alineada con la inteligencia del cuerpo.
            </p>
            <p data-id="element-157">
              Fue entonces cuando redescubrí antiguas fórmulas de activación
              masculina. Plantas como el Tongkat Ali, el Guaraná y la Canela
              Sagrada… pero las combiné con precisión bioquímica, en microdosis
              líquidas que el cuerpo puede absorber en segundos.
            </p>
            <p data-id="element-158">El resultado fue ImpulseEx.</p>
            <p data-id="element-159">
              No es un suplemento más. Es un protocolo de activación celular
              masculina, con resultados reales. Después de probarlo en mí, lo
              compartí con colegas y pacientes. Hoy, más de 1.400 hombres de
              Argentina están experimentando los mismos efectos: energía
              renovada, deseo espontáneo, y un enfoque mental que hacía años no
              sentían.
            </p>
            <p data-id="element-160">
              Si sentís que algo en vos se apagó… quizás solo falta el código
              correcto para volver a encenderte.
            </p>
          </div>
          <div className="mt-6 text-center" data-id="element-161">
            <p className="font-bold text-gray-100" data-id="element-162">Dr. Mateo Rivas</p>
            <p className="text-gray-400 text-sm" data-id="element-163">
              Bioquímico Clínico – Especialista en Vitalidad Masculina
            </p>
            <div className="flex justify-center mt-2 space-x-4 text-xs text-gray-400" data-id="element-164">
              <span data-id="element-165">20+ años en laboratorios</span>
              <span data-id="element-166">1,400+ hombres reactivados</span>
            </div>
            <p className="text-xs text-gray-400 mt-1" data-id="element-167">
              Fórmula validada por la experiencia y la ciencia
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center" data-id="element-168">
          
          <HeartPulseIcon className="h-12 w-12 text-red-500" data-id="element-169" />
        </div>
      </div>
    </section>;
}